var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "processData" },
    [
      _c("div", { staticClass: "fd-nav-content" }, [
        _c("section", { staticClass: "dingflow-design" }, [
          _c("div", { staticClass: "zoom" }, [
            _c("div", {
              class: "zoom-out" + (_vm.nowVal == 50 ? " disabled" : ""),
              on: {
                click: function ($event) {
                  return _vm.zoomSize(1)
                },
              },
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.nowVal) + "%")]),
            _vm._v(" "),
            _c("div", {
              class: "zoom-in" + (_vm.nowVal == 300 ? " disabled" : ""),
              on: {
                click: function ($event) {
                  return _vm.zoomSize(2)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "box-scale",
              style:
                "transform: scale(" +
                _vm.nowVal / 100 +
                "); transform-origin: 50% 0px 0px;",
              attrs: { id: "box-scale" },
            },
            [
              _c("nodeWrap", {
                attrs: {
                  "node-config": _vm.nodeConfig,
                  "flow-permission": _vm.flowPermission,
                  "is-tried": _vm.isTried,
                  "table-id": _vm.tableId,
                  "type-str": _vm.lowCode,
                },
                on: {
                  "update:nodeConfig": function ($event) {
                    _vm.nodeConfig = $event
                  },
                  "update:node-config": function ($event) {
                    _vm.nodeConfig = $event
                  },
                  "update:flowPermission": function ($event) {
                    _vm.flowPermission = $event
                  },
                  "update:flow-permission": function ($event) {
                    _vm.flowPermission = $event
                  },
                  "update:isTried": function ($event) {
                    _vm.isTried = $event
                  },
                  "update:is-tried": function ($event) {
                    _vm.isTried = $event
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(0),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("errorDialog", {
        attrs: { visible: _vm.tipVisible, list: _vm.tipList },
        on: {
          "update:visible": function ($event) {
            _vm.tipVisible = $event
          },
        },
      }),
      _vm._v(" "),
      _c("promoter-drawer"),
      _vm._v(" "),
      _c("approver-drawer", {
        attrs: {
          "type-str": _vm.lowCode,
          "director-max-level": _vm.directorMaxLevel,
        },
      }),
      _vm._v(" "),
      _c("copyer-drawer", {
        attrs: {
          "type-str": _vm.lowCode,
          "director-max-level": _vm.directorMaxLevel,
        },
      }),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          staticClass: "condition_copyer",
          attrs: {
            "append-to-body": true,
            title: "条件设置",
            visible: _vm.$store.state.business.conditionDialog,
            wrapperClosable: false,
            direction: "rtl",
            size: "650px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(
                _vm.$store.state.business,
                "conditionDialog",
                $event
              )
            },
          },
        },
        [
          _vm.$store.state.business.conditionDialog
            ? _c("condition-dialog", { attrs: { id: _vm.curd_id } })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "end-node" }, [
      _c("div", { staticClass: "end-node-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "end-node-text" }, [_vm._v("流程结束")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }